<template>
  <loadingComponent ref="loadingComponent" :loading-text="$t('loading')">
    <template
      v-if="(determinesInspectionAction(['store']) && inspeccion && separateHouse === 0) || (determinesInspectionAction(['store']) && forceAppearance === true)"
    >
      <div class="container-fluid">
        <div class="text-right" style="display: flex;">
          <template
            v-if="(typeTable && ['houses-and-activities', 'field-management', 'programacion'].indexOf(typeTable) === -1) && (inspeccion && separateHouse === 0 || forceAppearance === true)"
          >
            <a
              href="javascript:void(0)"
              @click="addRow"
              class="btn btn-link btn-md"
            >{{ $t('add_row') }}</a>
          </template>
          <div v-if="mutable && inspeccion">
            <a
              href="javascript:void(0)"
              @click="addColumn"
              class="btn btn-link btn-md"
            >{{ $t('add_column') }}</a>
          </div>
          <span
            v-if="mutable && inspeccion && separateHouse == 0"
            style="width: 100%;"
            class="text-center"
          >{{ $t('percentage_of_added_activities') }}: {{ advance }} %</span>
        </div>
      </div>
    </template>

    <div class="table-responsive">
      <table class="excel-table-2007 fixed-width-table table-hover" ref="dynamicContractTable">
        <thead class="thead-light-blue">
          <tr>
            <th
              scope="col"
              v-for="(column, key) in columnsActivities"
              :key="`column-th-${key.toString()}`"
              v-if="column.visible"
              :class="getClassesHeaderTh(column, key)"
              :id="generateRandomNumber(10)"
            >
              <template
                v-if="!column.hide && inspeccion & determinesInspectionAction(['delete']) && typeTable === 'houses-and-activities'"
                class="th-text-position"
              >
                <a
                  href="javascript:void(0)"
                  @click="deleteColumn(column)"
                >
                  <icon name="minus-circle" size="fa-1x"></icon>
                </a>
              </template>

              <template
                v-if="column.title !== undefined"
                class="th-text-position"
              >
                <table class="fixed-width-table">
                  <tr class="shild-bold-blue"><td>{{ column.title }}</td></tr>
                </table>
              </template>
              <template
                v-else-if="column.titles !== undefined && column.titles.length > 0"
              >
                <table class="fixed-width-table">
                  <tr
                    v-if="column.totalForActivity && separateHouse == 0"
                    class="th-text-position shild-bold-blue"
                  >
                    <td>{{ getNumberFormat(column.totalForActivity) }}</td>
                  </tr>
                  <tr
                    v-for="(title, index) in column.titles"
                    :key="`div-th-${index.toString()}`"
                    class="th-text-position shild-bold-blue"
                  >
                    <td>
                      <template v-if="column.editable && inspeccion">
                        <vue-weirdotab
                          :data="column"
                          :index="index"
                          :includepercentage="1"
                          :placeholder="title"
                          :separateHouse="separateHouse"
                          v-on:keyup.native="__detectPercentage"
                        ></vue-weirdotab>
                      </template>
                      <template v-else-if="column.value.length > 0">
                        <template v-if="index === 0">
                          <v-truncate
                            clamp="..."
                            :length="20"
                            less="Menos"
                            action-class="text-danger"
                            :text="column.value[index] || ''"
                          ></v-truncate>
                        </template>
                        <template v-else>
                          {{ column.value[index] }}
                        </template>
                        <template v-if="index == 1 && separateHouse == 0"><span>%</span></template>
                      </template>
                      <template v-else>
                        {{ title }}
                      </template>
                    </td>
                  </tr>
                </table>
              </template>
            </th>

            <!-- Total -->
            <th
              v-if="mutable"
              scope="col"
              class="established-width text-center"
            >{{ $t('total_progress') }}</th>

            <!-- Percent -->
            <th
              v-if="mutable"
              scope="col"
              class="established-width text-center"
            >%</th>

            <!-- Accion -->
            <th
              v-if="(mutable && inspeccion) || (forceAppearance === true)"
              scope="col"
              class="established-width text-center"
            ></th>
          </tr>
        </thead>
        <!-- Contrato de construccion -->
        <tfoot v-if="mutable && separateHouse == 0 && getObjectSize(totalPercent) > 0">
          <tr>
            <td class="established-width text-center"></td>
            <td class="established-width text-center"></td>
            <td
              v-for="(percent, key) in totalPercent"
              :key="`footer-${key.toString()}`"
              v-if="percent.visible"
              class="text-center established-width"
            >{{ getNumberFormatPercent(percent.total) }}</td>
            <td class="established-width text-center">{{ getNumberFormat(sumHouses) }}</td>
            <td
              class="established-width text-center"
            >{{ getNumberFormatPercent(totalglobalpercentage) }}</td>
            <td class="established-width" v-if="mutable && inspeccion && determinesInspectionAction(['delete'])"></td>
          </tr>
        </tfoot>
        <tfoot v-else-if="!mutable && separateHouse == 0 && forceTotalDisplay && getObjectSize(footers) > 0 && getObjectSize(totalPercent) === 0">
          <!-- Contrato de infras -->
          <td class="established-width text-center"></td>
          <td class="established-width text-center"></td>
          <td class="established-width text-center"></td>
          <td class="established-width text-center"></td>
          <td class="established-width text-center">{{ getNumberFormat(footers.monto_contrato) }}</td>
          <td class="established-width text-center"></td>
          <td class="established-width text-center">{{ getNumberFormat(footers.monto_avance) }}</td>
          <td class="established-width text-center">{{ getNumberFormatPercent(footers.porcentaje_ejecutado) }}</td>
          <td class="established-width text-center"></td>
        </tfoot>
        <tfoot v-else-if="isArray(footers) && getObjectSize(footers) > 0">
          <td
              v-for="(footer, key) in footers"
              :key="`footer-${key.toString()}`"
              class="text-center established-width"
            >{{ footer }}</td>
        </tfoot>
        <tbody v-if="getObjectSize(rowHouses) > 0">
          <tr
            v-for="(row, index) in rowHouses"
            :key="`house-tr-${index.toString()}`"
            :id="generateRandomNumber(10)"
          >
            <td
              scope="row"
              v-for="(column, key) in row"
              v-if="column.visible"
              class="established-width"
              :style="getObjectSize(column.styles) ? column.styles : ''"
              :key="`house-td-${key.toString()}`"
            >
              <template v-if="(column.editable) && (inspeccion || column.type === 'checkbox' || column.type === 'file')">
                <vue-weirdotab
                  :data="column"
                  :index="index"
                  :inspeccion="inspeccion"
                  :separateHouse="separateHouse"
                  v-on:click.native="__checkbox"
                  v-on:change.native="__handleFileUpload"
                  v-on:changeData="getEventChangedData(column, row)"
                ></vue-weirdotab>
              </template>
              <template v-else-if="typeTable === 'field-management' && key > 1">
                {{ getNumberFormatPercent(column.value) }}
              </template>
              <template v-else>
                <span
                  v-on:click="__checkbox"
                  :data-index="index"
                  :data-attr="toJson(column)"
                >{{ column.text || column.value }}</span>
              </template>
            </td>
            <td
              v-if="mutable && row[0] !== undefined && row[0].visible"
              class="established-width text-center"
            >
              <template v-if="Array.isArray(totalHouses) && totalHouses[index] !== undefined">
                {{ getNumberFormat(totalHouses[index].total) }}
              </template>
              <template v-else-if="totalHouses && totalHouses.total !== undefined">
                {{ getNumberFormat(totalHouses.total) }}
              </template>
            </td>
            <td
              v-if="mutable && row[0] !== undefined && row[0].visible"
              class="established-width text-center"
            >
              <template v-if="Array.isArray(totalHouses) && totalHouses[index] !== undefined">
                {{ getNumberFormatPercent(totalHouses[index].percent) }}
              </template>
              <template v-else-if="totalHouses && totalHouses.percent !== undefined">
                {{ getNumberFormatPercent(totalHouses.percent) }}
              </template>
            </td>
            <td
              v-if="(mutable && row[0] !== undefined && row[0].visible && inspeccion) || (forceAppearance === true && row[0] !== undefined && row[0].visible)"
              class="established-width text-center"
            >
              <template v-if="determinesInspectionAction(['delete']) && row[0].editable">
                <a href="javascript:void(0)" @click="deleteRow(row)">
                  <icon name="minus-circle" size="fa-2x"></icon>
                </a>
              </template>
              <template v-if="determinesInspectionAction(['show']) && showRowDetail === true">
                <a href="javascript:void(0)" @click="__emitShowRowDetail(row)">
                  <icon name="eye" size="fa-2x"></icon>
                </a>
              </template>
              <template v-if="determinesInspectionAction(['markVisibility']) && showMarkVisibility === true && __getMarkVisibility(row) === false">
                <a href="javascript:void(0)" @click="__setMarkVisibilityTrue(row)">
                  <icon name="eye-slash" size="fa-2x"></icon>
                </a>
              </template>
              <template v-else-if="determinesInspectionAction(['markVisibility']) && showMarkVisibility === true && __getMarkVisibility(row) === true">
                <a href="javascript:void(0)" @click="__setMarkVisibilityFalse(row)">
                  <icon name="eye-slash" size="fa-2x"></icon>
                </a>
              </template>
              <template v-if="determinesInspectionAction(['markAsPaid']) && markAsPaid(row) && getMarkAsPaid(row) === false">
                <a href="javascript:void(0)" @click="setMarkAsPaidTrue(row)">
                  <icon name="check" size="fa-2x"></icon>
                </a>
              </template>
              <template v-else-if="determinesInspectionAction(['markAsPaid']) && markAsPaid(row) && getMarkAsPaid(row) === true">
                <a href="javascript:void(0)" @click="setMarkAsPaidFalse(row)">
                  <icon name="ban" size="fa-2x"></icon>
                </a>
              </template>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr class="alert alert-danger">
            <td
              :colspan="getObjectSize(columnsActivities)"
              class="text-center"
            >{{ $t('there_is_no_information') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </loadingComponent>
</template>
<script>
import { mapGetters } from 'vuex'

import {
  createFile,
  getFileName,
  getTheFirstInDicesDice,
} from '../plugins/helper'
import {
  getTheLastRow,
  setNewAssignment,
} from '../plugins/helperService'
import ComponentLoading from './Componentloading'
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  name: 'v-weirdo-table',
  extends: IncludeHelperComponent,
  components: {
    loadingComponent: ComponentLoading,
  },
  props: {
    /**
     * Almacena los valores marcados
     */
    checkbox: {
      type: Array,
      default: () => {
        return []
      },
    },
    /**
     * Almacena la información de las columnas
     * de la tabla a generar.
     */
    columns: {
      type: Array,
      default: () => {
        return []
      },
    },
    /**
     * Almacena información de las filas de la tabla a generar.
     */
    rows: {
      type: Array,
      default: () => {
        return []
      },
    },
    footers: {
      type: Object|Array,
      default: () => {
        return {}
      },
    },
    forceAppearance: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    forceTotalDisplay: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    inspeccion: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    mutable: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    separateHouse: {
      type: Number,
      default: () => {
        return 0
      },
    },
    sumHouses: {
      type: Number,
      default: () => {
        return 0
      },
    },
    totalContrato: {
      type: Number|String,
      default: () => {
        return 0
      },
    },
    totalHouses: {
      type: Array|Object,
      default: () => {
        return null
      },
    },
    totalPercent: {
      type: Array,
      default: () => {
        return []
      },
    },
    totalglobalpercentage: {
      type: Number,
      default: () => {
        return 0
      },
    },
    typeTable: {
      type: String,
      default: () => {
        return ''
      },
    },
    showRowDetail: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    showMarkVisibility: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      advance: 0,
      temporaryBox: {},
    }
  },
  created: function () {
    this.__detectPercentage()
    this.initializeCheckbox()
  },
  computed: {
    ...mapGetters(['loadingJimp', 'filesJimp', 'errorJimp']),
    rowHouses: function() {
      if (this.separateHouse === 0) {
        return this.rows
      }

      const rows = []
      const temp = []
      this.rows.forEach((row, index) => {
        temp.push(row)
      })
      rows.push(temp)

      return rows
    },
    columnsActivities: function() {
      const temp = []
      if (Object.keys(this.columns).length === 0 || !this.checkVariable(this.columns)) {
        return []
      }

      this.columns.forEach((column, index) => {
        const assign = Object.assign({}, column)
        if (assign.value && Array.isArray(assign.value) && this.checkVariable(this.totalContrato)) {
          assign.totalForActivity = (this.totalContrato * assign.value[1]) / 100
        }
        temp.push(assign)
      })

      return temp
    },
  },
  watch: {
    temporaryBox: function() {
      const id = this.temporaryBox.id
      if (!Array.isArray(this.checkbox[id]) && this.temporaryBox.checked) {
        this.checkbox[id] = []
        this.checkbox[id].push(this.temporaryBox.value)
      } else if (Array.isArray(this.checkbox[id]) && this.temporaryBox.checked) {
        this.checkbox[id].push(this.temporaryBox.value)
      } else if (Array.isArray(this.checkbox[id]) && !this.temporaryBox.checked) {
        const index = this.checkbox[id].indexOf(this.temporaryBox.value)
        if (index !== -1) {
          this.checkbox[id].splice(index, 1)
        }
      }
      this.$emit('setCheckActivities', this.checkbox)
    },
    filesJimp: function (records) {
      if (records && records.length > 0 && !this.loadingJimp) {
        records.forEach(record => {
          const { file, key, attributes } = record
          if (this.checkVariable(attributes) && this.checkVariable(attributes['data-index'])) {
            const index = attributes['data-index'].value
            if (this.checkVariable(index, this.rowHouses, this.rowHouses[index])) {
              const rows = this.rowHouses[index]
              if (rows && Array.isArray(rows)) {
                const objRow = rows.find(row => {
                  return row.type === 'file'
                })
                if (objRow) {
                  const type = getFileName(file.type, '/')
                  const name = `${index}-${file.name}.${type}`
                  this.$set(objRow, 'name', name)
                  if (!Array.isArray(objRow['files'])) {
                    objRow['files'] = []
                  }
                  this.$set(objRow['files'], key, createFile(file, name))
                }
              }
            }
          }
        })
      }
    },
  },
  methods: {
    initializeCheckbox() {
      if (this.checkbox && this.checkbox.length === 0) {
        try {
          Object.keys(this.rows).forEach(key => {
            const rows = this.rows[key]
            const result = getTheFirstInDicesDice(rows, 2, 3)
            if (result && Array.isArray(result) && result.length > 0 && result[0].type === 'checkbox') {
              this.checkbox[key] = []
              rows.forEach(row => {
                if (row.type === 'checkbox' && row.checked) {
                  this.checkbox[key].push(row.value)
                }
              })
            }
          })
        } catch (e) {
          console.error(e)
        }
      }
    },
    __checkbox(event) {
      const element = event.target
      const index = element.getAttribute('data-index')
      const type = element.type
      if (type === 'checkbox' && element.checked) {
        const value = !isNaN(element.value) ? parseInt(element.value) : element.value
        this.temporaryBox = {
          id: index,
          value,
          checked: element.checked,
        }
      } else if (type === 'checkbox' && !element.checked) {
        this.temporaryBox = {
          id: index,
          value: element.value,
          checked: element.checked,
        }
      }

      this.$emit('clickOnBody', element)
    },
    __handleFileUpload(event) {
      const element = event.target
      const { type, files, attributes } = element
      if (type === 'file') {
        this.$store.dispatch('alterWithJimp', { files, attributes })
      }
    },
    __detectPercentage() {
      if (!this.mutable || this.separateHouse === 1) {
        return 0
      }

      let percentage = 0
      for (const index in this.columns) {
        if (
          this.columns.hasOwnProperty(index) &&
          typeof this.columns[index].value === 'object' &&
          this.columns[index].value[1] !== undefined &&
          this.columns[index].visible
        ) {
          if (this.checkVariable(this.columns[index], this.columns[index].value[1])) {
            percentage = percentage + parseFloat(this.columns[index].value[1])
          }
        }
      }

      if (percentage > 100) {
        this.defaultSettingsToastSwal()
        this.swalTitle = this.$t('error_alert_title')
        this.swalText = this.$t('error_percentage_alert_text')
        this.positionedDialogToast()
      }

      this.advance = percentage

      return Math.round10(percentage, -2)
    },
    deleteColumn(column) {
      const id = column.idrow
      this.rowHouses.forEach((rows, index) => {
        if (rows[id]) {
          if (
            this.checkVariable(this.totalHouses) &&
            this.checkVariable(this.totalHouses[index])
          ) {
            this.totalHouses[index].total =
              this.totalHouses[index].total - rows[id].value
          }

          rows[id].visible = false
        }
      })

      if (this.separateHouse === 0) {
        const totalPercent = this.__addDisableRow(this.totalPercent, column)

        if (totalPercent) {
          totalPercent.visible = false
        }
      }

      const originalColumn = this.__addDisableRow(this.columns, column)

      if (originalColumn !== undefined) {
        column.visible = false
        originalColumn.visible = false

        this.__detectPercentage()
      }
    },
    deleteRow(row) {
      if (Array.isArray(row)) {
        const forceAppearance = !this.forceAppearance || this.forceAppearance === undefined
        let temp = this.separateHouse === 1 && forceAppearance ? this.totalHouses : 0

        row.forEach((r, index) => {
          if (this.separateHouse === 0 && forceAppearance) {
            temp = this.totalHouses.find(house => house.id === r.id)
          }

          if (temp !== undefined && r.visible && forceAppearance) {
            this.$set(temp, 'visible', false)
          }

          r.visible = false
        })
      }
    },
    __addValueToKey(row, key, value) {
      if (this.checkVariable(row) && this.isArray(row)) {
        row.forEach(r => {
          if (this.checkVariable(r.styles)) {
            this.$set(r, 'styles', {
              background: value === true ? '#94f774' : '#dcabab',
              color: '#000',
              'font-weight': 'bold',
            })
          }
          this.$set(r, key, value)
        })
      }
    },
    __findKey(row, key) {
      const first = this.getTheFirstOccurrenceByKey(row, true, key)
      const value = this.getObjectValue(first, key)
      if ((this.checkVariable(first)) && (this.getValueNumber(value) === 1 || value === true)) {
        return true
      }

      return false
    },
    markAsPaid(row) {
      const first = this.getTheFirstOccurrenceByKey(row, 'cheques', 'lugar')

      return this.checkVariable(first) || false
    },
    setMarkAsPaidTrue(row) {
      this.$emit('setMarkAsPaidTrue', row)
      this.__addValueToKey(row, 'aprobado', true)
    },
    setMarkAsPaidFalse(row) {
      this.$emit('setMarkAsPaidFalse', row)
      this.__addValueToKey(row, 'aprobado', false)
    },
    getMarkAsPaid(row) {
      return this.__findKey(row, 'aprobado')
    },
    __setMarkVisibilityTrue(row) {
      this.__addValueToKey(row, 'visibility', true)
    },
    __setMarkVisibilityFalse(row) {
      this.__addValueToKey(row, 'visibility', false)
    },
    __getMarkVisibility(row) {
      return this.__findKey(row, 'visibility')
    },
    __getTheLastRow(rows) {
      return getTheLastRow(rows)
    },
    addRow(e) {
      // Add row
      const row = this.__getTheLastRow(this.rowHouses)
      const tempdata = setNewAssignment(row)

      // Apply insertion
      this.rowHouses.push(tempdata)
    },
    addColumn(e) {
      const porcentaje = this.__detectPercentage()
      if (porcentaje >= 100) {
        this.defaultSettingsToastSwal()
        this.swalTitle = this.$t('error_alert_title')
        this.swalText = this.$t('error_percentage_alert_text')
        this.positionedDialogToast()

        return
      }

      // Add Column
      const column = this.__getTheLastRow(this.columns)
      const tempdata = setNewAssignment(column)
      tempdata[0].idrow = this.columns[this.columns.length - 1].idrow + 1

      // Apply insertion
      this.columns.push(tempdata[0])

      // Add display column
      this.rowHouses.forEach((row, index) => {
        const temp = this.__mapObjectData(row)
        if (Object.keys(temp).length > 0) {
          row.push(temp)
        }
      })
    },
    __addDisableRow(data, row) {
      return data.find(element => {
        return (
          element.visible === true &&
          element.lugar === row.lugar &&
          element.id === row.id
        )
      })
    },
    __mapObjectData(row) {
      const newtemp = this.__getTheLastRow(row)
      const newTempWithValues = newtemp[0]
      const keys = Object.keys(newTempWithValues)
      const temp = {}

      keys.forEach((v, k) => {
        if (this.checkVariable(newTempWithValues[v])) {
          temp[v] = newTempWithValues[v]
          if (v === 'id') {
            temp[v] = 0
          }
        }
      })

      return temp
    },
    getEventChangedData(data, rows) {
      this.$emit('addExecutionEvent', data, rows)
    },
    getClassesHeaderTh(column, key) {
      let textVertical = ''
      if (key > 1) {
        textVertical = 'text-vertical-align-top'
      }
      const classWidth = this.checkVariable(column) && this.checkVariable(column.width) ? `established-width-${column.width}` : 'established-width'

      return `text-center ${textVertical} ${classWidth}`
    },
    __emitShowRowDetail(row) {
      this.$store.dispatch('emitShowRowDetail', row)
    },
  },
}
</script>
